import { render } from "./ContactUs.vue?vue&type=template&id=16a40802&scoped=true"
import script from "./ContactUs.vue?vue&type=script&scoped=true&lang=js"
export * from "./ContactUs.vue?vue&type=script&scoped=true&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=16a40802&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a40802"]])

export default __exports__